import React, { useState, useEffect } from "react";
import * as sdk from "microsoft-cognitiveservices-speech-sdk";
import { getTokenOrRefresh } from "../utils/token_util";

const useAzureSpeech = () => {
  const [transcript, setTranscript] = useState("");
  const [isListening, setIsListening] = useState(false);
  const [error, setError] = useState();
  const [interimTranscript, setInterimTranscript] = useState("");
  const recognizerRef = React.useRef(null);

  useEffect(()=>{
    setTranscript(transcript+interimTranscript)
  },[interimTranscript])
  const startListening = async () => {
    const tokenObj = await getTokenOrRefresh(); // Implement your token retrieval logic
    const speechConfig = sdk.SpeechConfig.fromAuthorizationToken(
      tokenObj.authToken,
      tokenObj.region
    );
    speechConfig.speechRecognitionLanguage = "en-US";

    const audioConfig = sdk.AudioConfig.fromDefaultMicrophoneInput();
    const recognizer = new sdk.SpeechRecognizer(speechConfig, audioConfig);

    recognizer.recognizeOnceAsync((result) => {
      if (result.reason === sdk.ResultReason.RecognizedSpeech) {
        setInterimTranscript(result.text);
      } else {
        setError("Failed to decode the speech.");
      }
      setIsListening(false);
    });

    recognizerRef.current = recognizer;

    setIsListening(true);
  };

  const stopListening = () => {
    if (recognizerRef.current) {
      recognizerRef.current.stopContinuousRecognitionAsync();
      setIsListening(false);
    }
  };

  useEffect(() => {
    return () => {
      stopListening(); // Clean up when the component unmounts
    };
  }, []);

  return {
    transcript: transcript,
    isListening,
    setTranscript,
    startListening,
    stopListening,
    error,
    setError,
  };
};

export default useAzureSpeech;
